<section class="rate">
  <p class="f-body-2xs f-medium f-muted">
    {{ `${I18N}.rate` | translate | uppercase }}
  </p>

  <div class="container f-body-xs">
    <div class="prices">
      <div class="item f-body-s f-medium">
        <p class="f-muted">{{ 'labels.net' | translate }}</p>

        {{ settlementData().net | onyxAmount: 'value' : false }}
      </div>

      <div class="item">
        @let vatRate = settlementData().vat.vatRate;
        <p class="f-muted">
          {{ 'labels.vat' | translate }} ({{ vatRate
          }}{{ CommonHelper.isNumeric(vatRate) ? '%' : '' }})
        </p>

        {{ settlementData().vat | onyxAmount: 'value' : false }}
      </div>

      <div class="item">
        <p class="f-muted">{{ 'labels.gross' | translate }}</p>

        {{ settlementData().gross | onyxAmount: 'value' : false }}
      </div>
    </div>

    <div class="information">
      <div class="wrapper f-body-s">
        <span class="f-muted">{{ 'labels.paymentTerm' | translate }}</span>

        @if (contractor$() | async; as contractor) {
          {{ contractor.payment.termDays }} {{ 'labels.days' | translate }}
        } @else {
          -
        }
      </div>

      <p class="f-body-xs f-muted">{{ `${I18N}.nbpRate` | translate }}</p>
    </div>
  </div>
</section>
